///
/// EarthBrowser
///
/// Migration: v42 -> v43
/// Enables the weather alerts dataset by default
///
/// Created by Matt Giger on 9/15/2026
/// Copyright (c) 2026 Geodata Labs
///

interface StateV42 {
	earthbrowser?: {
		visibleDatasets?: string[]
	}
}

/**
 * Migration from version 42 to 43: Add weather alert dataset support
 * - Adds "alert" to visibleDatasets so official weather alerts (NWS, ECCC,
 *   MeteoAlarm) show by default, matching the other default-on hazard layers
 *
 * Note: Redux freezes state objects, so we must return a new object rather than mutate
 */
export function migrateV42toV43(state: unknown): unknown {
	if (!state) {
		return state
	}

	const s = state as StateV42
	const oldEarthbrowser = s.earthbrowser || {}

	const visibleDatasets = Array.isArray(oldEarthbrowser.visibleDatasets)
		? [...oldEarthbrowser.visibleDatasets]
		: ["cloud", "earthquake", "satellite", "aurora", "volcano", "wildfire", "hurricane"]

	if (!visibleDatasets.includes("alert")) {
		visibleDatasets.push("alert")
	}

	return {
		...s,
		earthbrowser: {
			...oldEarthbrowser,
			visibleDatasets,
		}
	}
}
